import { Signal } from '@angular/core';
import { EnvironmentStore } from '@nx-vigil/core/web/environment/data-access';
import { Attributes } from '@opentelemetry/api';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import {
  BatchLogRecordProcessor,
  BufferConfig,
  LogRecordExporter,
  SdkLogRecord,
} from '@opentelemetry/sdk-logs';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { firstValueFrom } from 'rxjs';
import { OTELAttributesService } from '../open-telemetry/otel-attributes.service';
import { registerOtelLogging } from '../open-telemetry/otel-logging';

interface LoggingConfig {
  level?: NgxLoggerLevel;
  serverLogLevel?: NgxLoggerLevel;
}

export function setupLogging(
  environment: EnvironmentStore,
  attributesProvider: OTELAttributesService,
  logger: NGXLogger,
): () => Promise<void> {
  return async () => {
    const logging: LoggingConfig = await firstValueFrom(
      environment.getConfiguration$('logging'),
    );

    logger.partialUpdateConfig({
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.LOG,
      ...logging,
      serverLoggingUrl: 'dummy-to-enable-server-logging',
    });

    const processor = new ContextBatchLogRecordProcessor(
      attributesProvider.attributes,
      new OTLPLogExporter({
        url: `${location.origin}/logs`,
      }),
    );

    registerOtelLogging(processor);

    logger.log('Logging initialized', logger.getConfigSnapshot());
  };
}

class ContextBatchLogRecordProcessor extends BatchLogRecordProcessor {
  public constructor(
    private readonly attributes: Signal<Attributes>,
    _exporter: LogRecordExporter,
    config?: BufferConfig,
  ) {
    super(_exporter, config);
  }

  public override onEmit(logRecord: SdkLogRecord): void {
    logRecord.setAttributes(this.attributes());

    super.onEmit(logRecord);
  }
}
